import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { PartnerElement } from "../../../models/PartnersInBranch";
import { toCamelCase } from "../../../hooks/toCameCase.tsx";
import { formatDate, isValidImageUrl } from "../../../utils/index.ts";
import ButtonLink from "../../ButtonLink.tsx";

const RowPartnetDocuments = ({ data }: { data: PartnerElement }) => {
  const [open, setOpen] = React.useState(false);
  const [images, setImages] = React.useState({
    ine: false,
    perfil: false,
    solicitud: false,
    domicilio: false,
  });

  const getFilteredDocumentsCount = () => {
    const documentsToExclude = [
      "Pruebas psicométricas aplicadas por reclutamiento",
      "Pruebas psicométricas",
      "Alta en el IMSS (alta ingresada por contabilidad, no se visualiza este rubro)",
      "IMSS",
      "Constancia de semanas cotizadas en el IMSS",
    ];

    const filteredInmediate =
      data.documents.missingDocuments.missingDocumentsInmediate.filter(
        (file) =>
          !documentsToExclude.some((excluded) =>
            file.name.toLowerCase().includes(excluded.toLowerCase())
          )
      );

    const filteredNoInmediate =
      data.documents.missingDocuments.missingDocumentsNoInmediate.filter(
        (file) =>
          !documentsToExclude.some((excluded) =>
            file.name.toLowerCase().includes(excluded.toLowerCase())
          )
      );

    return filteredInmediate.length + filteredNoInmediate.length;
  };

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <i className="fa-solid fa-sort-up" />
            ) : (
              <i className="fa-solid fa-sort-down" />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {toCamelCase(
            `${data.partner.person.firstName} ${data.partner.person.lastName} ${data.partner.person.secondLastName}`
          )}
        </TableCell>
        <TableCell>{data.partner.candidate.vacancy.position.name}</TableCell>
        <TableCell>{formatDate(String(data.recruitmentDate))}</TableCell>

        <TableCell align="center">
          {data.hasCredentials ? (
            <i
              className="fa-solid fa-thumbs-up"
              style={{ fontSize: "24px", color: "#36e060" }}
            />
          ) : (
            <i
              className="fa-solid fa-thumbs-down"
              style={{ fontSize: "24px", color: "#ff5766" }}
            />
          )}
        </TableCell>
        <TableCell align="center">{getFilteredDocumentsCount()}</TableCell>
        <TableCell align="center">
          <ButtonLink
            className="btn btn-primary m-2"
            text={<i className="fa-solid fa-eye"></i>}
            to={`/colaboradores/detalles/${data.partner?.id}/`}
            type="button"
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{
                margin: 2,
                padding: 2,
                background: "linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)",
                borderRadius: "12px",
              }}
            >
              {(() => {
                const documentsToExclude = [
                  "Pruebas psicométricas aplicadas por reclutamiento",
                  "Pruebas psicométricas",
                  "Alta en el IMSS (alta ingresada por contabilidad, no se visualiza este rubro)",
                  "IMSS",
                  "Constancia de semanas cotizadas en el IMSS",
                ];

                const filteredInmediate =
                  data.documents.missingDocuments.missingDocumentsInmediate.filter(
                    (file) =>
                      !documentsToExclude.some((excluded) =>
                        file.name.toLowerCase().includes(excluded.toLowerCase())
                      )
                  );

                const filteredNoInmediate =
                  data.documents.missingDocuments.missingDocumentsNoInmediate.filter(
                    (file) =>
                      !documentsToExclude.some((excluded) =>
                        file.name.toLowerCase().includes(excluded.toLowerCase())
                      )
                  );

                const totalFiltered =
                  filteredInmediate.length + filteredNoInmediate.length;

                return totalFiltered === 0 ? (
                  <div
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      color: "#6B7280",
                      fontSize: "14px",
                    }}
                  >
                    <i
                      className="fa-solid fa-check-circle"
                      style={{
                        fontSize: "32px",
                        color: "#50B7C0",
                        marginBottom: "8px",
                      }}
                    ></i>
                    <div>No hay documentos pendientes</div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(280px, 1fr))",
                      gap: "12px",
                    }}
                  >
                    {filteredInmediate.map((file) => (
                      <div
                        key={file.id}
                        style={{
                          background: "#fff",
                          padding: "12px 16px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "12px",
                          border: "1px solid #fee2e2",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flex: 1,
                          }}
                        >
                          <i
                            className="fa-solid fa-file-alt"
                            style={{ color: "#9CA3AF", fontSize: "16px" }}
                          ></i>
                          <span
                            style={{
                              fontSize: "13px",
                              color: "#374151",
                              fontWeight: "500",
                            }}
                          >
                            {file.name}
                          </span>
                        </div>
                        <span
                          style={{
                            background:
                              "linear-gradient(135deg, #fecaca 0%, #fca5a5 100%)",
                            color: "#991b1b",
                            padding: "4px 12px",
                            borderRadius: "12px",
                            fontSize: "11px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            whiteSpace: "nowrap",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          }}
                        >
                          <i
                            className="fa-solid fa-bolt"
                            style={{ fontSize: "10px", marginRight: "4px" }}
                          ></i>
                          Inmediato
                        </span>
                      </div>
                    ))}

                    {filteredNoInmediate.map((file) => (
                      <div
                        key={file.name}
                        style={{
                          background: "#fff",
                          padding: "12px 16px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          border: "1px solid #e5e7eb",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <i
                          className="fa-solid fa-file-alt"
                          style={{ color: "#9CA3AF", fontSize: "16px" }}
                        ></i>
                        <span
                          style={{
                            fontSize: "13px",
                            color: "#374151",
                            fontWeight: "500",
                          }}
                        >
                          {file.name}
                        </span>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default RowPartnetDocuments;

const RowDocument = ({
  name,
  icon,
}: {
  name: string;
  icon: React.ReactNode;
}) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        {name}
      </TableCell>
      <TableCell align="center">{icon}</TableCell>
    </TableRow>
  );
};
